export default "__VITE_ASSET__CcgVsMJ3__"